import React, { Component } from 'react';
import * as bs4 from "reactstrap"
// import * as MdIcon from 'react-icons/lib/md'
// import { browserHistory } from 'react-router';
// import { saveToLocalStorage } from '../localStorage';


// const { proxy, public_function } = require("../service")

const { proxy } = require('./ip_api.config')
const md5 = require('md5');

class Login extends Component {
	constructor(props) {
		super(props)
		this.state = {
			inUserName: "",
			inPassword: "",
			alertVisible: false,
			alertMsg: 'test',
		}
	}

	componentDidMount() {
		localStorage.clear();
	}

	handleInputChange = (e) => {
		const target = e.target
		const val = target.value
		const name = target.name
		this.setState({
			[name]: val
		})
	}
	handleKeyPress = (e) => {
		if (e.key === "Enter") {
			this.handleOnClick()
		}
	}
	handleOnClick = async (e) => {
		let self = this
		let id = this.state.inUserName, pass = md5(this.state.inPassword)

		if (id != "" && pass != "") {
			let url = proxy.main + "web-api/login/" + id + "&" + pass
			fetch(url)
				.then(response => response.json())
				.then((responseJson) => {
					console.log("responseJson", responseJson)
					if (responseJson.status == 200) {
						//self._callAPIWebNo(responseJson.result)
						self.setState({
							alertVisible: true,
							alertMsg: "Login success! Please wait....."
						}, () => {
							localStorage.setItem("ID_User", responseJson.result[0].ID_User)
							localStorage.setItem("Name", responseJson.result[0].Name)
							localStorage.setItem("DepartmentNo", responseJson.result[0].DepartmentNo)
							if (responseJson.result[0].DepartmentNo === 'D11') {
								setTimeout(() => {
									this.props.history.push({
										pathname: '/Flim'
									})
								}, 2000);
							} else if (responseJson.result[0].DepartmentNo === 'D10') {
								console.log('object f02 acc')
								setTimeout(() => {
									this.props.history.push({
										pathname: '/Acc'
									})
								}, 2000);
							} else {
								setTimeout(() => {
									this.props.history.push({
										pathname: '/Flim/ProductInfoTable'
									})
								}, 2000);
							}
						})
					} else {
						self.setState({
							alertVisible: true,
							alertMsg: "Login fails! Please check data again"
						})
					}
				}).catch((error) => {
					self.setState({
						alertVisible: true,
						alertMsg: "Login fails! Please check data again"
					})
				})
		} else {
			alert("กรุณากรอกข้อมูลให้ครบ")
		}

	}
	// async _callAPIWebNo(result) {
	//     var urlWebNo = proxy.main + "web-api/webno/" + result[0].ID_User + "&18007"
	//     var res_api =await public_function.api_get(urlWebNo, "getWebNo")
	//     console.log("res_api",res_api)
	//     //saveToLocalStorage("data_webno", res_api)
	// }

	render() {
		return (
			<div><br /><br /><br /><br />
				<bs4.Container>
					<bs4.Row>
						<bs4.Col>
							<bs4.Card>
								<bs4.CardHeader>
									{/* <MdIcon.MdAccountCircle style={{ fontSize: '36px', color: '#0783C1' }} /> */}
                                    User Login
                    </bs4.CardHeader>
								<bs4.CardBody>
									<bs4.Form>
										<bs4.FormGroup>
											<bs4.Label for="exampleEmail">User Name</bs4.Label>
											<bs4.Input type="text" id="inUserName" name="inUserName" onKeyPress={this.handleKeyPress} autoFocus placeholder="User Name" onChange={this.handleInputChange} value={this.state.inUserName} />
										</bs4.FormGroup>
										<bs4.FormGroup>
											<bs4.Label for="exampleEmail">Password</bs4.Label>
											<bs4.Input type="password" onKeyPress={this.handleKeyPress} id="inPassword" name="inPassword" placeholder="Password" onChange={this.handleInputChange} value={this.state.inPassword} />
										</bs4.FormGroup>
									</bs4.Form>
									<bs4.Button color="success" className="btnLong" onClick={this.handleOnClick} >LOGIN</bs4.Button>
								</bs4.CardBody>
								<bs4.CardFooter>
									<bs4.Alert color="info" isOpen={this.state.alertVisible}>{this.state.alertMsg}</bs4.Alert>
								</bs4.CardFooter>
							</bs4.Card>
						</bs4.Col>
					</bs4.Row>
				</bs4.Container>
			</div >
		);
	}
}

export default Login;